import { ProgressBar } from '../../../components/ProgressBar';
import { useCreateOperator } from '../../../contexts/CreateOperatorContext';
import { ResponseMessage } from '../../../components/ResponseMessage';
import React from 'react';

export const ResultsProgress = () => {
  const { progress, summary } = useCreateOperator();
  const isSuccess = summary.every((step) => step.completed);

  if (progress.completed === false)
    return (
      <>
        <p>{progress.currentStep.name}</p>
        <ProgressBar value={progress.percentage} showPercentage />
      </>
    );
  else
    return (
      <ResponseMessage
        responseType={isSuccess ? 'success' : 'error'}
        message={
          isSuccess ? 'Successfully Added Operator' : 'Failed to add Operator'
        }
        subMessage={
          isSuccess
            ? undefined
            : summary.find((s) => s.step === progress.currentStep.step)
                ?.error ?? 'error'
        }
      />
    );
};
